import * as React from 'react';

import { UitkIcon } from 'uitk-react-icons';

interface WhatsAroundListItemProps {
  accessibleCategory?: string;
  category?: string;
  iconId?: string;
  id?: string;
  liClassName?: string;
  liContent: string;
  displayIcons?: boolean;
}

export const WhatsAroundListItem: React.FunctionComponent<WhatsAroundListItemProps> = ({
  accessibleCategory,
  category,
  iconId,
  id,
  liClassName,
  liContent,
  displayIcons
}) => {
  if (!(liContent && category)) {
    return null;
  }

  return (
    <li className={liClassName} key={id}>
      {displayIcons && <UitkIcon id={iconId} name={category} title={accessibleCategory ? accessibleCategory : null} />}
      {liContent}
    </li>
  );
};
